import { useHasQuizResults } from '@mentimeter/quiz';
import { getIsQuizSlide } from '../utils/isQuizSlide';
import { useQuestionResults } from './question-results';
import { useQuestion } from './question';

export { useConfig } from '../misc/config';
export { DispatchProvider, useDispatch } from '../misc/dispatcher';
export { PaceProvider, usePace, useOptionalPace } from '../misc/pace';
export { PresentationProvider, usePresentation } from '../misc/presentation';
export { useQuestion, useSlide, QuestionProvider } from './question';
export { useQfa } from '../misc/qfa/state';
export { useQuestionResults } from './question-results';
export { ReactionsResultsProvider } from '../misc/reactions-results';
export { StatusProvider } from '../status-indicators/errors/state';
export { TranslationProvider, useTranslate } from '../../state/translation';
export {
  trackToggleHotkeyOverlay,
  useHotkeyOverlay,
} from '../misc/overlays/hotkey';
export {
  TestVotesProvider,
  useTestVotesState,
} from '../misc/presentation-actions/testVotes';
export { CountdownProvider, useCountdownState } from './countdown';
export { PresentationActionsProvider } from '../misc/presentation-actions';
export { SlideActionsProvider } from '../misc/slide-actions';
export { ShowMediaProvider } from '../misc/media-overlay/state';
export { useSessions, SessionsProvider } from './session';
export { useTheme } from '../misc/themes/state';
export { useTrendsResults, TrendsProvider } from './trends';
export { useClustering } from '../../state/clustering';
export { VoteCodeProvider, useVoteCode } from '../misc/vote-code/state';
export {
  useToolbarModals,
  ToolbarModalsProvider,
} from '../toolbar/toolbar-modals';
export type { QuestionResults } from './question-results';

export const useAllRespondents = () => {
  const { type } = useQuestion();
  const isQuizResultsType = getIsQuizSlide(type);
  const hasQuizResults = useHasQuizResults();
  const { respondents = 0 } = useQuestionResults() ?? {};

  if (isQuizResultsType) return hasQuizResults ? 1 : 0;

  return respondents;
};
export type { SfinxPaceState } from '../misc/pace';
